import { FC, useMemo, useCallback } from 'react'
import { ManualAccountForm } from 'components/molecules/forms/ManualAccountForm'
import { createManualBalanceAccountSelector } from 'selectors/linkageSelectors'
import { ManualAccountFormData, ManualBalanceAccount, WithLinkageSessionId } from 'interfaces/linkage'
import { killLinkageSessionActionCreator } from 'actions/linkageActions'
import { MANUAL_ACCOUNT_FORM_INITIAL_VALUES, FORM_MANUAL_ACCOUNT } from 'constants/forms'
import { destroy, getFormValues } from 'redux-form'
import { useShallowSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { useCidBySessionId } from 'helpers/linkageHelpers'

const getFormInitialValues = (filledFormValues: ManualAccountFormData | undefined, manualBalanceAccount: ManualBalanceAccount | null): ManualAccountFormData => {
  const formValues = filledFormValues || {}

  if (!manualBalanceAccount) {
    return {
      ...MANUAL_ACCOUNT_FORM_INITIAL_VALUES,
      ...formValues,
    }
  }

  const { name, amount, category } = manualBalanceAccount

  return {
    name,
    amount: {
      sign: amount < 0 ? -1 : 1,
      absValue: Math.abs(amount),
    },
    category,
    ...formValues,
  }
}


type ManualAccountCreationProps =
  & WithLinkageSessionId
  & {
    onClose: () => void
  }

export const ManualAccountCreation: FC<ManualAccountCreationProps> = (props) => {
  const { sessionId, onClose } = props
  const { withCid } = useCidBySessionId(sessionId)
  const accountSelector = createManualBalanceAccountSelector()
  const manualBalanceAccount = useShallowSelector((state) => accountSelector(state, withCid))

  const formValuesSelector = useMemo(() =>
    getFormValues(FORM_MANUAL_ACCOUNT)
  , [])
  const formValues = useShallowSelector(formValuesSelector)
  const formInitialValues = getFormInitialValues(formValues as ManualAccountFormData, manualBalanceAccount)

  const dispatch = useStoreDispatch()
  const handleCancel = useCallback(() => {
    onClose()

    if (sessionId) {
      dispatch(killLinkageSessionActionCreator(sessionId))
    }

    dispatch(destroy(FORM_MANUAL_ACCOUNT))
  }, [onClose, sessionId, dispatch])

  if (!withCid.cid) {
    return null
  }

  return (
    <ManualAccountForm
      cid={ withCid.cid }
      initialValues={ formInitialValues }
      onCancel={ handleCancel }
    />
  )
}
